import { render, staticRenderFns } from "./brandRxCost.vue?vue&type=template&id=4da3328f"
import script from "./brandRxCost.vue?vue&type=script&lang=js"
export * from "./brandRxCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports